/**
 * @file Utilitas eksekusi promise terbatas paralelisme per chunk (berguna untuk batch API tanpa membanjiri server).
 */

/**
 * Menjalankan async iterator per blok: paling banyak `poolLimit` promise berjalan paralel dalam satu blok,
 * lalu blok berikutnya. Satu item gagal tidak membatalkan item lain di blok yang sama (Promise.all).
 *
 * @template T, R
 * @param {number} poolLimit - Maksimum iterator yang berjalan bersamaan per blok (min. 1).
 * @param {T[]} array - Koleksi input.
 * @param {(item: T) => Promise<R>} iteratorFn - Fungsi async per item.
 * @returns {Promise<R[]>} Hasil dalam urutan yang sama dengan `array`.
 */
// eslint-disable-next-line import/prefer-default-export
export async function asyncPool(poolLimit, array, iteratorFn) {
  const limit = Math.max(1, poolLimit)
  const runChunk = async start => {
    if (start >= array.length) return []
    const slice = array.slice(start, start + limit)
    const chunkResults = await Promise.all(slice.map(item => iteratorFn(item)))
    const rest = await runChunk(start + limit)
    return chunkResults.concat(rest)
  }
  return runChunk(0)
}
